.screen {
	min-height: 100%;
	padding: var(--space-5);
	max-width: var(--screen-max);
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: var(--space-3);
}

.mapWrap {
	position: relative;
	flex: 1;
	min-height: 60dvh;
}

.map {
	width: 100%;
	height: 100%;
	min-height: 60dvh;
	border-radius: var(--radius-md);
	overflow: hidden;
	background: var(--surface-input);
}

.overlay {
	position: absolute;
	inset: var(--space-3);
	display: grid;
	place-items: center;
	padding: var(--space-4);
	background: color-mix(in srgb, var(--surface-card) 92%, transparent);
	border-radius: var(--radius-md);
	color: var(--ink-muted);
	pointer-events: none;
	z-index: 500;
}

/* Popup content built imperatively by buildPopup() — classes referenced
   from JS via the styles object, so they need to be declared here. */
.popup {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 140px;
}

.popupMeta {
	font-size: 0.8rem;
	color: var(--ink-muted);
}

.popupLink {
	color: var(--accent-sage);
	font-weight: 600;
	text-decoration: none;
	font-size: 0.85rem;
}

.popupLink:hover {
	text-decoration: underline;
}
